import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
//import SidebarLeft from "../SidebarLeft";
//import SidebarRight from "../SidebarRight";
import "./CallsAwards.css";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
function DsmDiary() {
  const [contentDsmDiary, setContentDsmDiary] = useState(null);
  /*
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_dsm_diary`)
      .then((response) => {
        const data = response.data;
        setContentDsmDiary(data);
      })
      .catch((error) => {
        //alert("ERRORE | get_dsm_diary");
        //console.log("DsmDiary | get_dsm_diary | error", error);
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const handleDownloadClick = (event, year, file) => {
    event.preventDefault();
    axios
      .get(`${serverConfig.serverUrl}/file/dsm_diary/${year}/${file}`, {
        responseType: "blob", // Indica ad Axios che la risposta è un blob (file)
      })
      .then((response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.split("/").pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        //alert("'Errore durante il download del file");
        toast.error("La risorsa non è al momento scaricabile");
      });
  };

  /*
  const viewDsmDiary = (
    <div className="board-of-directors-info">
      {contentDsmDiary &&
        Object.keys(contentDsmDiary)
          .sort((a, b) => b - a) // Ordina in ordine decrescente
          .map((year) => (
            <div key={year} className="row" style={{ marginTop: "20px" }}>
              <h1
                style={{
                  backgroundColor: "#F5F7FA",
                  textAlign: "center",
                  color: "#003366",
                  borderRadius: "20px",
                  border: "2px solid #D8DEE9",
                }}
              >
                <strong>{year}</strong>
              </h1>
              <div></div>
              {Object.keys(contentDsmDiary[year])
                .sort((a, b) => b - a) // Ordina in ordine decrescente
                .map((order) => (
                  <div key={order} className="row" style={{ margin: "20px" }}>
                    {contentDsmDiary[year][order]
                      .sort((a, b) => a.internal_order - b.internal_order) // Ordina in ordine crescente
                      .map((item, index) => (
                        <div
                          className="row"
                          key={index}
                          style={{
                            border: "2px solid #D8DEE9",

                            borderRadius: "10px",
                            padding: "20px",
                          }}
                        >
                          <div
                            className="col-2"
                            style={{
                              textAlign: "center",
                              border: "2px solid #D8DEE9",
                              backgroundColor: "#F5F7FA",
                              color: "#2C2C2C",
                              borderRadius: "20px",
                            }}
                          >
                            {item.info}
                          </div>
                          {item.file !== "" && (
                            <div className="col-10">
                              <div
                                style={{
                                  border: "2px solid #D8DEE9",
                                  borderRadius: "10px",
                                  padding: "10px",
                                }}
                              >
                                <div>
                                  <button
                                    style={{
                                      margin: "5px",
                                      borderRadius: "10px",
                                      backgroundColor: "white",
                                      color: "#003366",
                                      border: "2px solid #D8DEE9",
                                    }}
                                    onClick={() =>
                                      window.open(
                                        `${serverConfig.serverUrl}/file/dsm_diary/${item.year}/${item.file}`,
                                        "_blank"
                                      )
                                    }
                                  >
                                    APRI IN UNA NUOVA FINESTRA
                                  </button>
                                  <button
                                    style={{
                                      margin: "5px",
                                      borderRadius: "10px",
                                      backgroundColor: "#003366",
                                      color: "white",
                                      border: "2px solid #D8DEE9",
                                    }}
                                  >
                                    <a
                                      href={`${serverConfig.serverUrl}/file/dsm_diary/${item.year}/${item.file}`}
                                      download
                                      rel="noopener noreferrer"
                                      style={{
                                        marginRight: "20px",
                                        color: "white",
                                      }}
                                      onClick={(e) =>
                                        handleDownloadClick(
                                          e,
                                          item.year,
                                          item.file
                                        )
                                      }
                                      draggable={false}
                                      onDragStart={(e) => e.preventDefault()}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-download-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0m-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708z"
                                        />
                                      </svg>
                                      <label style={{ marginLeft: "10px" }}>
                                        SCARICA
                                      </label>
                                    </a>
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                ))}
            </div>
          ))}
    </div>
  );
  */

  // uno per riga
  /*
  const viewDsmDiary = (
    <div className="board-of-directors-info">
      {contentDsmDiary &&
        Object.keys(contentDsmDiary)
          .sort((a, b) => b - a) // Ordina in ordine decrescente
          .map((year) => (
            <div key={year} style={{ marginTop: "20px" }}>
              <h1
                style={{
                  backgroundColor: "#F5F7FA",
                  textAlign: "center",
                  color: "#003366",
                  borderRadius: "20px",
                  border: "2px solid #D8DEE9",
                }}
              >
                <strong>{year}</strong>
              </h1>

              {Object.keys(contentDsmDiary[year])
                .sort((a, b) => b - a) // Ordina in ordine decrescente
                .map((order) => {
                  const items = contentDsmDiary[year][order].sort(
                    (a, b) => a.internal_order - b.internal_order
                  );

                  // Dividere gli elementi in coppie
                  const pairs = [];
                  for (let i = 0; i < items.length; i += 2) {
                    pairs.push(items.slice(i, i + 2));
                  }

                  return (
                    <div key={order} style={{ margin: "20px" }}>
                      {pairs.map((pair, pairIndex) => (
                        <div className="row" key={pairIndex}>
                          <>{JSON.stringify(pairIndex)}</>
                          {pair.map((item, index) => (
                            <div
                              className="col-12 col-lg-6"
                              key={index}
                              style={{
                                border: "2px solid #D8DEE9",
                                backgroundColor: "#F5F7FA",
                                color: "#2C2C2C",
                                borderRadius: "20px",
                                padding: "10px",
                              }}
                            >
                              <strong>{item.info}</strong>
                              {item.file !== "" && (
                                <div>
                                  <button
                                    style={{
                                      margin: "5px",
                                      borderRadius: "10px",
                                      backgroundColor: "white",
                                      color: "#003366",
                                      border: "2px solid #D8DEE9",
                                    }}
                                    onClick={() =>
                                      window.open(
                                        `${serverConfig.serverUrl}/file/dsm_diary/${item.year}/${item.file}`,
                                        "_blank"
                                      )
                                    }
                                  >
                                    APRI IN UNA NUOVA FINESTRA
                                  </button>
                                  <button
                                    style={{
                                      margin: "5px",
                                      borderRadius: "10px",
                                      backgroundColor: "#003366",
                                      color: "white",
                                      border: "2px solid #D8DEE9",
                                    }}
                                  >
                                    <a
                                      href={`${serverConfig.serverUrl}/file/dsm_diary/${item.year}/${item.file}`}
                                      download
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "white",
                                        textDecoration: "none",
                                      }}
                                      onClick={(e) =>
                                        handleDownloadClick(
                                          e,
                                          item.year,
                                          item.file
                                        )
                                      }
                                    >
                                      SCARICA
                                    </a>
                                  </button>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  );
                })}
            </div>
          ))}
    </div>
  );
  */

  const viewDsmDiary = (items) => {
    if (!items) return null; // Se items è undefined/null, non fare nulla

    // Convertiamo l'oggetto in un array [{year: 2014, events: [...]}, {year: 2015, events: [...]}]
    const groupedEvents = Object.entries(items).map(([year, months]) => ({
      year,
      events: Object.values(months)
        .flat() // Unisci tutti gli eventi dell'anno
        .sort((a, b) => b.order - a.order), // Ordina gli eventi per 'order'
    }));

    return (
      <>
        {groupedEvents
        .sort((a, b) => b.year - a.year)
        .map(({ year, events }) => (
          <div key={year}>
            {/* Titolo dell'anno */}
            <div
              style={{
                color: "#F5F7FA",
                textAlign: "center",
                fontSize: "20px",
                borderRadius: "10px",
                border: "2px solid #D8DEE9",
                backgroundColor: "#003366",
                marginTop: "20px",
                padding: "10px",
              }}
            >
              {year}
            </div>

            {/* Dividiamo gli eventi in coppie di due */}
            {Array.from({ length: Math.ceil(events.length / 2) }, (_, i) =>
              events.slice(i * 2, i * 2 + 2)
            ).map((pair, pairIndex) => (
              <div className="row" key={pairIndex}>
                {pair.map((item, itemIndex) => (
                  <>
                    {/*}
                  <div className="col-12 col-lg-6" key={itemIndex}>
                    {JSON.stringify(item)}
                  </div>
                  */}

                    <div className="col-12 col-md-6" key={itemIndex}>
                      <div
                        style={{
                          border: "2px solid #D8DEE9",
                          backgroundColor: "#F5F7FA",
                          color: "#2C2C2C",
                          borderRadius: "10px",
                          margin: "10px",
                          padding: "10px",
                          textAlign: "center",
                        }}
                      >
                        <strong>{item.info}</strong>
                        {item.file !== "" && (
                          <div className="mt-2">
                            <button
                              className="btn btn-outline-primary"
                              onClick={() =>
                                window.open(
                                  `${serverConfig.serverUrl}/file/dsm_diary/${item.year}/${item.file}`,
                                  "_blank"
                                )
                              }
                            >
                              APRI IN UNA NUOVA FINESTRA
                            </button>
                            <a
                              href={`${serverConfig.serverUrl}/file/dsm_diary/${item.year}/${item.file}`}
                              download
                              className="btn btn-primary ms-2"
                              onClick={(e) =>
                                handleDownloadClick(e, item.year, item.file)
                              }
                            >
                              SCARICA
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            ))}
          </div>
        ))}
      </>
    );
  };

  /*
  return (
    <div
      className={`row home-container ${
        showSidebar ? "show-sidebar" : "hide-sidebar"
      }`}
    >
      <button
        className="show-sidebar-button"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
      </button>
      {window.innerWidth <= 992 ? (
        showSidebar ? (
          <div className="col-12">
            <SidebarLeft />
          </div>
        ) : (
          <div className={`main-content col-12`}>{componentsDiary}</div>
        )
      ) : (
        <>
          <div className="col-2 sidebar-left">
            <SidebarLeft />
          </div>
          <div className={`main-content ${showSidebar ? "col-10" : "col-12"}`}>
            {componentsDiary}
          </div>
        </>
      )}
    </div>
  );
  */

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //const componentDsmDiary = <>{viewDsmDiary}</>;
  const componentDsmDiary = (
    <>
      {<>{contentDsmDiary && viewDsmDiary(contentDsmDiary)}</>}
    </>
  );

  return (
    <div>
      {/*
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">{viewDsmDiary}</div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{componentDsmDiary}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {componentDsmDiary}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DsmDiary;
